import { Pipe, PipeTransform } from '@angular/core';
import {DashboardService} from "../../includes/dashboard/dashboard.service";
import {AuthService} from "../../services/auth.service";

@Pipe({
    name: 'audioDetail'
})export class AudioDetailPipe implements PipeTransform {
    currentUser: any;
    title = '';
    constructor(private dashboardService: DashboardService,
                private authService: AuthService) {
        this.currentUser = this.authService.currentUser;
    }
    async transform(note: any, args?: any) {
        let data = await this.dashboardService
            .getAudioDetailById(note.audio_id, this.currentUser._id,
                this.currentUser.auth_key, this.currentUser.user_type).toPromise();

        this.title = data.data.audio_title;
        return this.title;
    }
}
/////just a coment///